/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
import { StringTableCommon } from './common/StringTableCommon'
export const StringTable = [
  ...StringTableCommon,
  {
    "key": "orgs",
    "en": "Organisations"
  },
  {
    "key": "audio-ads",
    "en": "Audio Ads"
  },
  {
    "key": "display-ads",
    "en": "Disp Ads"
  },
  {
    "key": "venues",
    "en": "Screens"
  },
  {
    "key": "campaigns",
    "en": "Disp Campaigns"
  },
  {
    "key": "media",
    "en": "Media"
  },
  {
    "key": "mediaTags",
    "en": "Media Tags"
  },
  {
    "key": "brandNames",
    "en": "Brand Names"
  },
  {
    "key": "restrictionTags",
    "en": "Restriction Tags"
  },
  {
    "key": "manageDevices",
    "en": "Manage Screens"
  },
  {
    "key": "homeTagline",
    "en": "Manage Screens, Ads and more"
  },
  {
    "key": "accessConsole",
    "en": "Login"
  },
  {
    "key": "explainerImageAlt",
    "en": "Explainer Image"
  },
  {
    "key": "admins",
    "en": "Users"
  },
  {
    "key": "productadmins",
    "en": "Users"
  },
  {
    "key": "brandColours",
    "en": "Quick Pick"
  },
  {
    "key": "settingsMaster",
    "en": "Master Settings"
  },
  {
    "key": "applyFilter",
    "en": "Apply filter"
  },
  {
    "key": "filter",
    "en": "Filter"
  },
  {
    "key": "login",
    "en": "Create account / Login"
  },
  {
    "key": "loginDescr",
    "en": "You have created the campaign, let’s get inside your account to elevate your brand."
  },
  {
    "key": "enterOTP",
    "en": "Enter the OTP you received"
  },
  {
    "key": "letUsKnowYou",
    "en": "Let us know you!"
  },
  {
    "key": "resetAll",
    "en": "Reset All"
  },
  {
    "key": "noResults",
    "en": "No results found"
  },
  {
    "key": "filters",
    "en": "Filters"
  },
  {
    "key": "venuegroups",
    "en": "Screen Groups"
  },
  {
    "key": "campaignDetails",
    "en": "Campaign Details"
  },
  {
    "key": "userDetails",
    "en": "User Details"
  },
  {
    "key": "campaigns",
    "en": "Campaigns"
  },
  {
    "key": "emptyScreens",
    "en": "No Screens Found"
  },
  {
    "key": "campaignCost",
    "en": "Cost:"
  },
  {
    "key": "campaignBtnUpdate",
    "en": "Update campaign"
  },
  {
    "key": "campaignBtnCreate",
    "en": "Create campaign"
  },
  {
    "key": "venuefilters",
    "en": "Filter Screens"
  },
  {
    "key": "enterOrgTitle",
    "en": "Enter your business name"
  },
  {
    "key": "firstName",
    "en": "First name"
  },
  {
    "key": "lastName",
    "en": "Last name"
  },
  {
    "key": "Phone",
    "en": "Phone"
  },
  {
    "key": "enterOrgTitle",
    "en": "Enter your business name"
  },
  {
    "key": "enterGivenname",
    "en": "Enter your first name"
  },
  {
    "key": "enterFamilyname",
    "en": "Enter your last name"
  },
  {
    "key": "phone",
    "en": "Phone"
  },
  {
    "key": "selectScreens",
    "en": "Select Screens"
  },
  {
    "key": "selectAdfrequency",
    "en": "Select Ad Frequency"
  },
  {
    "key": "selectLocation",
    "en": "Select a location"
  },
  {
    "key": "campaignPg",
    "en": "Payment confirmation"
  },
  {
    "key": "emptyCampaigns",
    "en": "No campaigns found"
  },
  {
    "key": "adImageAlt",
    "en": "Ad image"
  },
  {
    "key": "closeLoginDialogAlt",
    "en": "Close dialog"
  },
  {
    "key": "tileIcon",
    "en": "Icon"
  },
  {
    "key": "actionRequired",
    "en": "Action required"
  },
  {
    "key": "pending",
    "en": "Pending"
  },
  {
    "key": "paused",
    "en": "Paused"
  },
  {
    "key": "live",
    "en": "Live"
  },
  {
    "key": "emptyCreatives",
    "en": "No creatives uploaded yet"
  },
  {
    "key": "venues",
    "en": "Screens"
  },
  {
    "key": "adInfo",
    "en": "Frequency is the number of times ad will be played in a 15-minutes window at a venue"
  },
  {
    "key": "paymentPending",
    "en": "Payment pending"
  },
  {
    "key": "pendingApproval",
    "en": "Pending approval"
  },
  {
    "key": "enabled",
    "en": "Enabled"
  },
  {
    "key": "disabled",
    "en": "Disabled"
  },
  {
    "key": "draft",
    "en": "Draft"
  },
  {
    "key": "emptyCreatives",
    "en": "No creatives added in this campaign yet"
  },
  {
    "key": "makePayment",
    "en": "Make payment"
  },
  {
    "key": "getPaymentLink",
    "en": "Generate payment link"
  },
  {
    "key": "viewPaymentLink",
    "en": "View payment link"
  },
  {
    "key": "submitReview",
    "en": "Submit for review"
  },
  {
    "key": "disableCampaign",
    "en": "Pause"
  },
  {
    "key": "enableCampaign",
    "en": "Enable campaign"
  },
  {
    "key": "campaignDuration",
    "en": "Campaign duration"
  },
  {
    "key": "creatives",
    "en": "Creatives"
  },
  {
    "key": "enterValidPhone",
    "en": "Enter valid phone number"
  },
  {
    "key": "campaignsSelfServe",
    "en": "Self Serve Campaigns"
  },
  {
    "key": "help",
    "en": "Help"
  },
  {
    "key": "ac",
    "en": "Reseller Tracking Code (optional)"
  },
  {
    "key": "cancelCampaign",
    "en": "Cancel campaign"
  },
  {
    "key": "cancelCampaignMessage",
    "en": "This will permanently stop your campaign. You will no longer be billed for this campaign. Do you want to cancel?"
  },
  {
    "key": "continue",
    "en": "Continue"
  },
  {
    "key": "cancelCampaignConfirmationButton",
    "en": "Yes, Cancel"
  },
  {
    "key": "cancelled",
    "en": "Cancelled"
  },
  {
    "key": "paymentConditions",
    "en": "I agree to sign up for a monthly subscription. I understand that I can cancel the subscription at any time."
  },
  {
    "key": "revenue",
    "en": "Revenue"
  },
  {
    "key": "revenueVenue",
    "en": "Revenue"
  },
  {
    "key": "tags",
    "en": "Screen Tags"
  },
  {
    "key": 'selectTags',
    "en": 'Select tags'
  },
  {
    "key": "assets",
    "en": "Assets"
  },
  {
    "key": "mediaPickerTitle",
    "en": "Pick from media"
  },
  {
    "key": "mediaEmpty",
    "en": "No media found"
  },
  {
    "key": "mediaDuration",
    "en": "Duration"
  },
  {
    "key": "itemsCountText",
    "en": "Total Media"
  },
  {
    "key": "addNewMedia",
    "en": "Add Media"
  },
  {
    "key":"scheduleCampaign",
    "en":"Schedule"
  },
  {
    "key":"venueInfo",
    "en":"Screen Info"
  },
  {
    "key":"mediaDeleted",
    "en":"Media Deleted"
  },
  {
    "key":"placementNotSet",
    "en":"Placement not set"
  },
  {
    "key": "scrollText",
    "en": "Your scrolling text goes here Your scrolling text goes here Your scrolling text goes here Your scrolling text goes here Your scrolling text goes here Your scrolling text Your scrolling text goes here Your scrolling text goes here."
  },
  {
    "key": "android",
    "en": "Android"
  },
  {
    "key": "unknown",
    "en": "Unknown"
  },
  {
    "key": "optionListLoadingText",
    "en": "Updating..."
  },
  {
    "key": "bulkUpdate",
    "en": "Bulk Update"
  },
  {
    "key": "download",
    "en": "Download"
  },
  {
    "key": "venueExplorer",
    "en": "Screen Explorer"
  },
  {
    "key":"jobs",
    "en": "Jobs"
  },
  {
    "key": "dialogCloseAlt",
    "en": "Close"
  },
  {
    "key": "latLngNotFound",
    "en": "Latitude/Longitude is not available"
  },
  {
    "key": "osVersion",
    "en": "OS Version"
  },
  {
    "key": "sendCommandTitle",
    "en": "Send Command to Screen"
  },
  {
    "key": "adsPlayButtonTitle",
    "en": "Play Ads"
  },
  {
    "key": "noAdsFound",
    "en": "No ads found for this screen."
  },
  {
    "key": "venueAdsLoadingText",
    "en": "Loading..."
  },
  {
    "key": "clearLocation",
    "en": "Clear Location"
  },
  {
    "key": "noVenue",
    "en": "No screens on this site yet"
  },
  {
    "key": "noAssets",
    "en": "No assets found"
  },
  {
    "key": "noTask",
    "en": "No tasks found"
  },
  {
    "key": "noLayout",
    "en": "No layouts found"
  },
  {
    "key": "listVenues",
    "en": "Screens"
  },
  {
    "key": "bulkAttach",
    "en": "Attach (Paste)"
  },
  {
    "key": "bulkDetach",
    "en": "Detach (Paste)"
  },
  {
    "key": "campaignUpdateSuccess",
    "en": "Campaign updated successfully."
  },
  {
    "key": "campaignUpdateFailed",
    "en": "Campaign update failed."
  },
  {
    "key": "invalidFileWidth",
    "en": "Maximum video width allowed is 1920 pixels. Current video width is %s pixels."
  },
  {
    "key": "invalidFileHeight",
    "en": "Maximum video height allowed is 1920 pixels. Current video height is %s pixels."
  },
  {
    "key": "maxDurationVideo",
    "en": "Duration is too long, max duration is %second% Seconds."
  },
  {
    "key": "maxDurationImage",
    "en": "Duration must be between (5 to 15 secs)"
  },
  {
    "key": "displayOrderLength",
    "en": "Display order is high, max order is 999."
  },
  {
    "key": "adpopreport",
    "en": "Reports"
  },
  {
    "key": "address",
    "en": "Address: "
  },
  {
    "key": "noAddress",
    "en": "N/A"
  },
  {
    "key": "unknown",
    "en": "N/A"
  },
  {
    "key": "dashboard",
    "en": "Dashboard"
  },
  {
    "key": "upload",
    "en": "Upload"
  },
  {
    "key": "tipMediaDnd",
    "en": "Tip: Drag and drop media to the left panel to add in campaign"
  },
  {
    "key": "emptyMediaDnd",
    "en": "No media found"
  },
  {
    "key": "dragTipMessage",
    "en": "Tip : Drag to rearrange the order of the media"
  },
  {
    "key": "reports",
    "en": "CMS"
  },
  {
    "key": "reportsPartner",
    "en": "CMS Reports"
  },
  {
    "key": "creativesModeration",
    "en": "Creatives Review"
  },
  {
    "key": "exchangeReports",
    "en": "Exchange Reports"
  },
  {
    "key":"noChartDataMessage",
    "en": "No data available"
  },
  {
    "key":"customField",
    "en": "Custom Fields"
  },
  {
    "key":"addCustomField",
    "en": "Custom Fields (No Custom Field found)"
  },
  {
    "key":"fieldOptions",
    "en": "Field Suggestions"
  },
  {
    "key":"suggestions",
    "en": "Suggestions"
  },
  {
    "key":"users",
    "en": "Users"
  },
  {
    "key":"suggestionFieldLabel",
    "en": "Suggestion"
  },
  {
    "key":"customFieldLabel",
    "en": "Custom Field Label"
  },
  {
    "key": "addRule",
    "en": "Add Rule"
  },
  {
    "key": "saveExpression",
    "en": "Save"
  },
  {
    "key": "inSyncMessageTooltip",
    "en": "Synced with latest changes"
  },
  {
    "key": "inSyncMessage",
    "en": "In-sync"
  },
  {
    "key": "ouOfSyncMessage",
    "en": "Out-of-sync"
  },
  {
    "key": "hdmi",
    "en": "HDMI"
  },
  {
    "key": "hdmi_connected",
    "en": "HDMI Connected"
  },
  {
    "key": "hdmi_not_connected",
    "en": "HDMI Not Connected"
  },
  {
    "key": "tasks",
    "en": "Tasks"
  },
  {
    "key": "subTask",
    "en": "Subtasks"
  },
  {
    "key": "mediaDisabled",
    "en": "MEDIA OFF"
  },
  {
    "key": "scheduleApplied",
    "en": "Schedule is applied"
  },
  {
    "key": "scheduleTitle",
    "en" : "Schedule Details"
  },
  {
    "key": "addLogo",
    "en": "Logo"
  },
  {
    "key": "displayImages",
    "en": "Display Images"
  },
  {
    "key": "uploadImages",
    "en": "Uploaded Images",
  },
  {
    "key": "layouts",
    "en": "Layouts"
  },
  {
    "key": "createLayout",
    "en": "Create New"
  },
  {
    "key": "newLayout",
    "en": "Select Template"
  },
  {
    "key": "templateSetting",
    "en": "Template Setting"
  },
  {
    "key": "newSection",
    "en": "Add new section"
  },
  {
    "key": "addOverlay",
    "en": "Add Overlay"
  },
  {
    "key": "autoFill",
    "en": "Auto Fill"
  },
  {
    "key":"makeCustomLayout",
    "en": "Custom Layout"
  },
  {
    "key": "deleteSelected",
    "en": "Remove Selected Section"
  },
  {
    "key": "layoutTitleLabel",
    "en": "Layout"
  },
  {
    "key": "totalMedia",
    "en": "Total Media"
  },
  {
    "key": "duration",
    "en": "Duration"
  },
  {
    "key": "save",
    "en": "Save"
  },
  {
    "key": "saveAndPreview",
    "en": "Preview"
  },
  {
    "key": "createdOn",
    "en": "Created on",
  },
  {
    "key": "completedOn",
    "en": "Completed on",
  },
  {
    "key": "setting",
    "en": "Settings",
  },
  {
    "key": "apply",
    "en": "Apply",
  },
  {
    "key": "sampleVenueCode",
    "en": "Screen Codes ( Eg: DD-886547, DD-886459, DD-325352 )",
  },
  {
    "key": "sampleCampaignCode",
    "en": "Campings Id ( Eg: 1690349875526-1705555309420, 1694177067745-171203214477 )",
  },
  {
    "key": "maxCampaignCode",
    "en": "Maximum entries allowed is %n%",
  },
  {
    "key": "maxVenueCode",
    "en": "Maximum entries allowed is %n%",
  },
  {
    "key": "edit",
    "en": "Edit",
  },
  {
    "key": "layoutNameRequired",
    "en": "Layout Name is required.",
  },
  {
    "key": "durationSecsRequired",
    "en": "Duration Seconds is required.",
  },
  {
    "key": "videoPresent",
    "en": "Only one section can contain videos."
  },
  {
    "key": "noSpaceToAddSection",
    "en" : "No space available to add the section."
  },
  {
    "key": "newOverlay",
    "en": "Add new overlay"
  },
  {
    "key": "maxOverlayMsg",
    "en" : "Maximum MAX_OVERLAY_NUMBER overlays allowed."
  },
  {
    "key": "overlayVideoNotAllowedMessage",
    "en" : "Only images and text can be added to an overlay."
  },
  {
    "key": "weather",
    "en": "WEATHER"
  },
  {
    "key": "assetTextAlt",
    "en" : "TEXT"
  },
  {
    "key": "programmaticAdsMayRepeat",
    "en": "Programmatic ads and the above ads may repeat"
  },
  {
    "key": "cmsAdsWillRepeat",
    "en": "Above CMS ads will repeat"
  },
  {
    "key": "assetHdmiAlt",
    "en" : "HDMI-IN"
  },
  {
    "key": "hdmiPresent",
    "en": "Only one section can contain HDMI-IN."
  },
  {
    "key": "progCmsPresent",
    "en": "Only one section can contain PROG-CMS."
  },
  {
    "key": "menu",
    "en": "Menu"
  },
  {
    "key": "notSupported",
    "en": "This functionality is available only on larger desktops"
  },
  {
    "key": "oneSectionOneMedia",
    "en": "A section can contain only one source"
  },
  {
    "key": "screenSettings",
    "en": "Screen Settings"
  },
  {
    "key": "mediaAndDetails",
    "en": "Campaign Details"
  },
  {
    "key": "rejectedOn",
    "en": "Rejected on",
  },
  {
    "key": "addSubTask",
    "en": "Add Sub Task",
  },
  {
    "key": "taskDetails",
    "en": "Task Details",
  },
  {
    "key": "paymentSuccess",
    "en": "Thank you! Your payment was successful."
  },
  {
    "key": "venueDetails",
    "en": "Screen Details"
  },
  {
    "key": "deviceHistory",
    "en": "Device History"
  },
  {
    "key": "networkInfo",
    "en": "Network Info"
  },
  {
    "key": "campaignHistory",
    "en": "Campaign History"
  },
  {
    "key": "bulkUpload",
    "en": "Bulk Upload"
  },
  {
    "key": "uploadFailed",
    "en": "Upload failed. Try uploading again."
  },
  {
    "key": "noMediaToSave",
    "en": "Please upload a valid media to save."
  },
  {
    "key": "okay",
    "en": "Okay"
  },
  {
    "key": "fileSaveFailed",
    "en": "Failed to save the file. Try again."
  },
  {
    "key": "fileIsStillUploading",
    "en": "File upload in progress. Please wait until all uploads are finished."
  },
  {
    "key": "addToMedia",
    "en": "Add to Media"
  },
  {
    "key": "maxFilesAllowedNo",
    "en": "Maximum NO_OF_FILE files can be selected."
  },
  {
    "key": "fileTypeNotSupported",
    "en": "File is unsupported. Please select only images or videos."
  },
  {
    "key": "noVenueImage",
    "en": "Screen image not present."
  },
  {
    "key": "selectVenuesToDownload",
    "en": "Select screens to download"
  },
  {
    "key": "devicesActivity",
    "en": "Devices Acitivity Report"
  },
  {
    "key": "readyToSave",
    "en": "Ready to Save"
  },
  {
    "key": "fileTitleValidationMessage",
    "en": "Nickname is too short (2 - 100)"
  },
  {
    "key": "liveLocation",
    "en": "Live Location"
  },
  {
    "key": "notAvailable",
    "en": "Not available"
  },
  {
    "key": "orgSwitcher",
    "en": "Switch View"
  },
  {
    "key": "selectOrg",
    "en": "Select Account"
  },
  {
    "key": "dateErr",
    "en": "End date/time must be after start date/time."
  },
  {
    "key": "partnerReport",
    "en": "External Report"
  },
  {
    "key": "internalReport",
    "en": "Internal Report"
  },
  {
    "key": "searchExchangeReports",
    "en": "Search Exchange Reports by Screen Code"
  },
  {
    "key": "deviceActivitySearchError",
    "en": "You can enter only one screen code"
  },
  {
    "key": "deviceActivitySearchHint",
    "en": "Search by Screen Code (e.g DD-886547)"
  },
  {
    "key": "ddSearchHint",
    "en": "Search Exchange Ads"
  },
  {
    "key": "deviceExchangeReports",
    "en": "Exchange Reports: "
  },
  {
    "key": "imageOrientationMismatch",
    "en": "Image does not match the selected orientation."
  },
  {
    "key": "partnerExchangeReports",
    "en": "Partner Exchange Reports"
  },
  {
    "key": "partnerAdApiExchangeReports",
    "en": "AD API Exchange Reports"
  },
  {
    "key": "invalidDownload",
    "en": "Nothing to download"
  },
  {
    "key": "dateRangeExceededForDaReport",
    "en": "The maximum allowed date range is 7 days"
  },
  {
    "key": "dateRangeExceededForDpsReport",
    "en": "The maximum allowed date range is 30 days"
  },
  {
    "key": "ddCreatives",
    "en": "DD Creatives (OTT)"
  },
  {
    "key": "revDateRangeExceeded",
    "en": "The date range cannot exceed 12 months."
  },
  {
    "key": "addNewSp",
    "en": "Add New Super Partner"
  },
  {
    "key": "addNew",
    "en": "Add New Org"
  },
  {
    "key": "DdSearch",
    "en": "Exchange Creatives"
  },
  {
    "key": "screenHealthSummary",
    "en": "Screen Health"
  },
  {
    "key": "fleetSnapshot",
    "en": "Screens Latest Snapshot"
  },
  {
    "key": "screenHistory",
    "en": "Screen History"
  },
  {
    "key": "screenHealthEnterScreenCode",
    "en": "Enter a screen code."
  },
  {
    "key": "screenHealthSelectDateRange",
    "en": "Select a start and end date."
  },
  {
    "key": "screenHealthInvalidDateRange",
    "en": "Select a valid start and end date."
  },
  {
    "key": "screenHealthMaxDateRange",
    "en": "The maximum allowed date range is %n% days"
  },
  {
    "key": "screenHealthTimeseriesReport",
    "en": "Screen Health Timeseries Report"
  },
  {
    "key": "screenHealthReportLatencyNote",
    "en": "There may be upto 12 hours of latency in the report"
  },
  {
    "key": "ScreenPerformanceDashboard",
    "en": "Screen Fill Rate"
  },
  {
    "key": "screenPerformanceTopScreensTitle",
    "en": "Top 1000 Screens With Programatic Spots (OOH & OTT Combined)"
  },
  {
    "key": "venueFillRate",
    "en": "Playback History"
  },
  {
    "key": "reportsTitle",
    "en": "Reports"
  },
  {
    "key": "restrictionTags",
    "en": "Restriction Tags"
  },
  {
    "key": "exReports",
    "en": "Exchange"
  },
  {
    "key": "approvals",
    "en": "Approvals"
  },
  {
    "key": "showDetails",
    "en": "Show Details"
  },
  {
    "key": "screenHealth",
    "en": "Screen Health"
  },
  {
    "key": "screenFillRate",
    "en": "Screen Fill Rate"
  },
  {
    "key": "ApproveOrBlock",
    "en": "Approve or Block"
  },
  {
    "key": "screenOttRenderrate",
    "en": "OTT Ad Render Rate Analysis"
  }
]



// WEBPACK FOOTER //
// ./src/StringTable.js